import dayjs, { type Dayjs } from 'dayjs'

export type ApplicationReviewFormValues = {
  memberMode: 'existing' | 'create'
  memberId?: number
  type: 'employee'
  name?: string
  phone?: string
  email?: string
  jobTitle?: string
  isSalesperson: boolean
  hireDate?: Dayjs | null
  note?: string
  roleIds: string[]
}

export function toApplicationHireDate(value: Dayjs | null | undefined) {
  return value ? dayjs(`${value.format('YYYY-MM-DD')}T00:00:00.000Z`).toDate() : null
}

type ApplicationReviewSource = {
  applicantName: string
  applicantPhone: string | null
  account: { email: string }
}

export function getApplicationReviewInitialValues(application?: ApplicationReviewSource): ApplicationReviewFormValues {
  return {
    email: application?.account.email ?? '',
    memberMode: 'create',
    name: application?.applicantName ?? '',
    phone: application?.applicantPhone ?? '',
    isSalesperson: false,
    hireDate: undefined,
    roleIds: [],
    type: 'employee'
  }
}
